import {
  participantFormIds,
  participantEligibilityWarning,
  participantNameConditions,
  allParticipantPages
} from 'Src/helpers/twoPanelEditor/participantFilters';
import * as React from 'react';
import Lazy from 'lazy.js';
import propz from 'propz';
import Moment from 'moment';
import { AppUser } from '../../../../../App/App';
import { History, Location } from 'history';
import { DATE_INTERVAL, DEFAULT_LIMIT, DEFAULT_SKIP, FILTER_TYPE, LIMIT } from '../../../../../../consts/table';
import { TEAM_TYPE } from '../../../../../../consts/team';
import { CLUB_EVENT_EDIT_MODE } from '../../../../../../consts/event';
import { SPORT_GENDER_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/common';
import { AGE_GROUPS } from '../../../../../../consts/school';
import { Loader } from '../../../../../../components/Loader/Loader';
import { StatusModal } from 'Src/components/StatusModal/StatusModal';
import { TwoPanelEditor } from '../../../../../../components/TwoPanelEditor/TwoPanelEditor';
import { Button } from '../../../../../../components/Button/Button';
import { SimpleModal } from '../../../../../../components/SimpleModal/SimpleModal';
import { HelpModal } from 'Src/components/HelpModal/HelpModal';
import { HelpIconButton } from 'Src/components/HelpIconButton/HelpIconButton';
import {
  getPersonListSortedByName,
  ColumnDefinition,
  getOrder,
  getServerFieldSectionWhere,
  isFilterExist2,
  TABLE_SORT_DIRECTION
} from '../../../../../../helpers/table/table';
import { getAge, getEventGeneratedName, getGender } from '../../../../../../helpers/accessor/accessor';
import { getTwoPanelEditorFilters } from '../../../../../../helpers/twoPanelEditor/twoPanelEditor';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import { getAllHouses } from 'Src/helpers/service/admin/houses';
import {
  getSelectOptionForAge,
  getSelectOptionForForms,
  getSelectOptionForGender,
  getSelectOptionForHouses
} from '../../../../../../helpers/table/select';
import { getUserGenderArrayConvertedFromEventGender } from '../../../../../../helpers/tournament/tournament';
import { getSchoolEvent, updateSchoolEventTeamPlayersBatch } from 'Src/helpers/service/admin/event';
import { getAllClubParticipants } from 'Src/helpers/service/admin/clubParticipants';
import { addClubStudents } from 'Src/helpers/service/admin/clubStudents';
import {
  getClashEventDisplayTitle,
  getStudentsMethod,
  getTeamPlayersMethod,
  isClubEvent,
  isTeamSportEvent,
  isTournamentEvent,
  isHousesEvent,
  isTeamOrTwoOnTwoSportEvent
} from '../../../../../../helpers/event/event';
import { getFromHistory } from '../../../../../../helpers/history/history';
import {
  addSchoolEventTeam,
  addSchoolTournamentTeam,
  getSchoolTournamentTeams
} from 'Src/helpers/service/admin/tournamentTeams';
import { updateSchoolTournamentTeamPlayersBatch } from 'Src/helpers/service/admin/tournamentTeamPlayers';
import { SchoolEvent } from '../../../../../../models/event';
import { getSchoolEventTeam, updateSchoolEventTeam } from 'Src/helpers/service/admin/schoolEventTeams';
import {
  getSchoolStudentsWithClashesCount,
  getSchoolStudentsWithoutClashes
} from '../../../../../../helpers/service/admin/schoolTeamPlayers';
import { getSchoolEventTeamPlayersCount } from '../../../../../../helpers/service/admin/schoolEventTeamPlayers';
import { updateSchoolEventIndividualsGroupBatch } from '../../../../../../helpers/service/admin/schoolEventIndividuals';
import { createTeamScore } from 'Src/helpers/service/admin/eventResults';
import { getEventStartDateAndTime } from 'Src/helpers/event/schoolEventViewHelper';
import { formatAgesCompact } from 'Src/helpers/ageGroups';
import { getColorClashes } from '../../../../../../helpers/cell/cell';
import { SchoolStudentClash } from '../../../../../../models/schoolStudent';
import { TournamentTeam } from 'Src/models/tournamentTeam';
import { SchoolForm } from '../../../../../../models/form';
import { SchoolHouse } from '../../../../../../models/house';
import { SchoolEventTeamPlayerWithClashes } from '../../../../../../models/eventTeamPlayer';
import { SchoolEventClubEventRadioButtons } from '../SchoolEventClubEventRadioButtons/SchoolEventClubEventRadioButtons';
import '../SchoolEventManager.scss';

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  isSelectingAll?: boolean;
  selectionError?: string;
  items: Item[];
  itemsSelected: Item[];
  itemsCount: number;

  itemsFilters: any;
  isShowItemsFilter: boolean;
  isItemsFiltered: boolean;

  isSelectAllItemsChecked: boolean;

  sortItemsDirection: TABLE_SORT_DIRECTION;
  sortItemsColumnsName: string;

  itemCurrentPage: number;

  itemsAccumulatorInitial: Item[];
  itemsAccumulator: Item[];
  itemsAccumulatorSelected: Item[];
  itemsAccumulatorCount: number;

  itemsAccumulatorFilters: any;
  isShowItemsAccumulatorFilter: boolean;
  isItemsAccumulatorFiltered: boolean;

  isExitConfirmationModalOpen: boolean;

  isSelectAllItemsAccumulatorChecked: boolean;

  sortItemsAccumulatorDirection: TABLE_SORT_DIRECTION;
  sortItemsAccumulatorColumnsName: string;

  isLoading: boolean;
  isItemsLoading: boolean;
  isError: boolean;

  itemsAddBuffer: Item[];
  itemsRemoveBuffer: Item[];

  team: any;

  forms: SchoolForm[];
  houses: SchoolHouse[];

  event: SchoolEvent | undefined;
  teamName: string;
  isShowFollowingEventsSection: boolean;
  editMode: string;

  isStudentEventsModalOpen: boolean;
  isStudentClashLoading: boolean;
  studentClashStudentName: string;
  studentClashEvents: Array<{
    id: string;
    title: string;
    type: 'full' | 'interval';
  }>;
  tournamentTeams: TournamentTeam[];

  isHelpModalOpen: boolean;

  isMaxPlayersModalOpen: boolean;
  maxPlayersModalMessage: string;
  saveErrorMessage?: string;

  itemsHiddenFields: Set<string>;
  itemsAccumulatorHiddenFields: Set<string>;
  itemsSearch: string;
}

interface Item {
  id: string;
  permissionId: string;
  form: any;
  house: any;
  gender: string;
  firstName: string;
  lastName: string;
  clashes: {
    status?: string;
    fullClashEvents?: any[];
    intervalClashEvents?: any[];
  };
  playerId?: string;
  avatar?: string;
  birthday?: string;
  specialEducationNeeds?: boolean;
  pupilsPremium?: boolean;
  yearGroup?: string;
}

const ITEMS_ACCUMULATOR_COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'firstName',
    accessor: ['firstName'],
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Surname',
    field: 'lastName',
    accessor: ['lastName'],
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Form',
    field: 'forms',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: ['form', 'name'],
    isMobileHidden: true
  },
  {
    text: 'House',
    field: 'house',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: ['house', 'name'],
    isMobileHidden: true
  },
  {
    text: 'Age',
    field: 'ages',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getAge,
    isMobileHidden: true
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getGender,
    isMobileHidden: true
  }
];

const ITEMS_ACCUMULATOR_COLUMNS_WITH_CLASHES: ColumnDefinition[] = [
  {
    text: 'Clashes',
    field: 'clashes',
    cell: getColorClashes,
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Surname',
    field: 'lastName',
    accessor: ['lastName'],
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Name',
    field: 'firstName',
    accessor: ['firstName'],
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Form',
    field: 'forms',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: ['form', 'name'],
    isMobileHidden: true
  },
  {
    text: 'House',
    field: 'house',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: ['house', 'name'],
    isMobileHidden: true
  },
  {
    text: 'Age',
    field: 'ages',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getAge,
    isMobileHidden: true
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getGender,
    isMobileHidden: true
  }
];

const ITEMS_COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'firstName',
    accessor: ['firstName'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  {
    text: 'Surname',
    field: 'lastName',
    accessor: ['lastName'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  {
    text: 'Form',
    field: 'forms',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['form', 'name'],
    isMobileHidden: true
  },
  {
    text: 'House',
    field: 'houses',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['house', 'name'],
    isMobileHidden: true
  },
  {
    text: 'Age',
    field: 'ages',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getAge,
    isMobileHidden: true
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getGender,
    isMobileHidden: true
  }
];

const ITEMS_COLUMNS_WITH_CLASHES: ColumnDefinition[] = [
  {
    text: 'Clashes',
    field: 'clashes',
    cell: getColorClashes,
    type: FILTER_TYPE.NONE,
    isSort: false
  },
  {
    text: 'Surname',
    field: 'lastName',
    accessor: ['lastName'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  {
    text: 'Name',
    field: 'firstName',
    accessor: ['firstName'],
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  {
    text: 'Form',
    field: 'forms',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['form', 'name'],
    isMobileHidden: true
  },
  {
    text: 'House',
    field: 'houses',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['house', 'name'],
    isMobileHidden: true
  },
  {
    text: 'Age',
    field: 'ages',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getAge,
    isMobileHidden: true
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getGender,
    isMobileHidden: true
  }
];

const DEFAULT_TEAM_PLAYERS_ORDER = 'firstName ASC';

export class SchoolTeamManager extends React.Component<Props, State> {
  private clashEventTitleCache = new Map<string, string>();

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      itemsCount: 0,
      itemsSelected: [],

      itemsFilters: {},
      isShowItemsFilter: false,
      isItemsFiltered: false,

      isSelectAllItemsChecked: false,

      sortItemsDirection: '',
      sortItemsColumnsName: '',

      itemCurrentPage: 1,

      itemsAccumulatorInitial: [],
      itemsAccumulator: [],
      itemsAccumulatorCount: 0,
      itemsAccumulatorSelected: [],

      itemsAccumulatorFilters: {},
      isShowItemsAccumulatorFilter: false,
      isItemsAccumulatorFiltered: false,

      isSelectAllItemsAccumulatorChecked: false,

      sortItemsAccumulatorDirection: '',
      sortItemsAccumulatorColumnsName: '',

      isExitConfirmationModalOpen: false,

      isLoading: true,
      isItemsLoading: false,
      isError: false,

      itemsAddBuffer: [],
      itemsRemoveBuffer: [],

      team: undefined,
      forms: [],
      houses: [],

      event: undefined,
      teamName: '',
      isShowFollowingEventsSection: false,
      editMode: CLUB_EVENT_EDIT_MODE.SINGLE,

      isStudentEventsModalOpen: false,
      isStudentClashLoading: false,
      studentClashStudentName: '',
      studentClashEvents: [],
      tournamentTeams: [],

      isHelpModalOpen: false,

      isMaxPlayersModalOpen: false,
      maxPlayersModalMessage: '',
      saveErrorMessage: '',

      itemsHiddenFields: this.loadHiddenFields('teamManager_items'),
      itemsAccumulatorHiddenFields: this.loadHiddenFields('teamManager_accumulator'),
      itemsSearch: ''
    };
  }

  private itemsSearchRequestId = 0;

  private static ALWAYS_VISIBLE = new Set(['firstName', 'lastName', 'clashes']);

  private get storageUserId(): string {
    return this.props.user?.userId || 'anonymous';
  }

  private loadHiddenFields(key: string): Set<string> {
    const userId = this.props.user?.userId || 'anonymous';
    try {
      const raw = localStorage.getItem(`columnVisibility__${userId}__${key}`);
      if (!raw) return new Set();
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return new Set<string>(parsed);
    } catch {}
    return new Set();
  }

  private saveHiddenFields(key: string, fields: Set<string>): void {
    try {
      localStorage.setItem(`columnVisibility__${this.storageUserId}__${key}`, JSON.stringify(Array.from(fields)));
    } catch {}
  }

  isColumnToggleable = (field: string): boolean => !SchoolTeamManager.ALWAYS_VISIBLE.has(field);

  onToggleItemsColumn = (field: string): void => {
    if (SchoolTeamManager.ALWAYS_VISIBLE.has(field)) return;
    this.setState(prev => {
      const next = new Set(prev.itemsHiddenFields);
      next.has(field) ? next.delete(field) : next.add(field);
      this.saveHiddenFields('teamManager_items', next);
      return { itemsHiddenFields: next };
    });
  };

  onToggleItemsAccumulatorColumn = (field: string): void => {
    if (SchoolTeamManager.ALWAYS_VISIBLE.has(field)) return;
    this.setState(prev => {
      const next = new Set(prev.itemsAccumulatorHiddenFields);
      next.has(field) ? next.delete(field) : next.add(field);
      this.saveHiddenFields('teamManager_accumulator', next);
      return { itemsAccumulatorHiddenFields: next };
    });
  };

  getDefaultItemsFilter(team, event: SchoolEvent) {
    const isTeamExist = typeof team !== 'undefined';
    const { ages } = event;
    if (isTeamExist) {
      const { gender, houseId } = team;

      const genderArrayConverted = getUserGenderArrayConvertedFromEventGender(gender);

      return typeof houseId !== 'undefined'
        ? {
            firstName: '',
            lastName: '',
            gender: genderArrayConverted,
            forms: [],
            houses: [houseId],
            ages: ages
          }
        : {
            firstName: '',
            lastName: '',
            gender: genderArrayConverted,
            forms: [],
            ages: ages
          };
    } else {
      const { gender } = event;
      const genderArrayConverted = getUserGenderArrayConvertedFromEventGender(gender);
      const houseId = this.getHouseId();

      return isHousesEvent(event)
        ? {
            firstName: '',
            lastName: '',
            gender: genderArrayConverted,
            forms: [],
            ages: ages,
            houses: [houseId]
          }
        : {
            firstName: '',
            lastName: '',
            gender: genderArrayConverted,
            forms: [],
            ages: ages
          };
    }
  }

  getTeamId(): string {
    const { history } = this.props;
    return getFromHistory(history, 'team');
  }

  getEventId(): string {
    const { history } = this.props;
    return getFromHistory(history, 'event');
  }

  getHouseId(): string {
    const { history } = this.props;
    return getFromHistory(history, 'house');
  }

  openExistingTeamMode = () => {
    const eventId = this.getEventId();
    const houseId = this.getHouseId();
    const params = new URLSearchParams({ event: eventId });
    if (houseId) params.set('house', houseId);
    const teamId = this.getTeamId();
    if (this.state.event && isClubEvent(this.state.event) && teamId) params.set('team', teamId);
    this.props.history.push({ pathname: '/events/existingTeamManager', search: params.toString() });
  };

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    const { user } = this.props;
    const teamId = this.getTeamId();
    const eventId = this.getEventId();

    const itemsFilters = getTwoPanelEditorFilters(ITEMS_COLUMNS);
    const isShowItemsFilter = isFilterExist2(itemsFilters);
    const isItemsFiltered = isFilterExist2(itemsFilters);

    const itemsAccumulatorFilters = getTwoPanelEditorFilters(ITEMS_ACCUMULATOR_COLUMNS);
    const isShowItemsAccumulatorFilter = isFilterExist2(itemsAccumulatorFilters);
    const isItemsAccumulatorFiltered = isFilterExist2(itemsAccumulatorFilters);

    const isTeamIdExist = typeof teamId !== 'undefined';

    const teamPromise = isTeamIdExist ? getSchoolEventTeam(user, eventId, teamId) : Promise.resolve(undefined);
    const formsPromise = getAllForms(user);
    const housesPromise = getAllHouses(user);
    const eventPromise = getSchoolEvent(user, eventId);

    let team;
    let forms;
    let houses;
    let event;

    Promise.all([teamPromise, formsPromise, housesPromise, eventPromise])
      .then(([_team, _forms, _houses, _event]) => {
        team = _team;
        forms = _forms;
        houses = _houses;
        event = _event;
        const eventName = getEventGeneratedName(event, { user }) || 'Event';
        const tournamentName = propz.get(event, ['tournament', 'name'], '');
        const breadcrumb = tournamentName
          ? `${tournamentName} / Manage events / ${eventName} / Manage participants`
          : `${eventName} / Participants`;
        window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: breadcrumb }));

        if (isTournamentEvent(event)) {
          const { tournamentId } = event;

          return getSchoolTournamentTeams(user, tournamentId);
        }
      })
      .then(tournamentTeams => {
        const defaultItemsFilter = this.getDefaultItemsFilter(team, event);
        const isTeamExist = typeof team !== 'undefined';
        const houseId = this.getHouseId();
        const house = event.housesData.find(eventHouse => eventHouse.id === houseId);
        const houseName = propz.get(house, ['name'], '');

        isTeamExist
          ? this.setState({
              team,
              forms,
              houses,
              event,
              itemsFilters: defaultItemsFilter,
              teamName: team.name,
              tournamentTeams: isTournamentEvent(event) ? tournamentTeams || [] : []
            })
          : this.setState({
              forms,
              houses,
              event,
              itemsFilters: defaultItemsFilter,
              teamName: isHousesEvent(event) ? houseName : '',
              tournamentTeams: isTournamentEvent(event) ? tournamentTeams || [] : []
            });

        return this.getItemsAndItemsAccumulator();
      })
      .then(({ teamPlayersInitial, teamPlayers, teamPlayersCount, students, studentsCount }) => {
        const studentsNormalized = this.getStudentsNormalized(students);
        const teamPlayersNormalized = this.getTeamPlayersNormalized(teamPlayers);
        const teamPlayersInitialNormalized = this.getTeamPlayersNormalized(teamPlayersInitial);

        this.setState({
          items: studentsNormalized,
          itemsCount: studentsCount.count,
          isShowItemsFilter: isShowItemsFilter,
          isItemsFiltered: isItemsFiltered,

          itemsAccumulatorInitial: teamPlayersInitialNormalized,
          itemsAccumulator: teamPlayersNormalized,
          itemsAccumulatorCount: teamPlayersCount.count,
          itemsAccumulatorFilters: itemsAccumulatorFilters,
          isShowItemsAccumulatorFilter: isShowItemsAccumulatorFilter,
          isItemsAccumulatorFiltered: isItemsAccumulatorFiltered,

          isLoading: false
        });
      });
  }

  componentWillUnmount() {
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
  }

  hydrateClashEventTitles = async <T extends { clashes?: any }>(people: T[]): Promise<T[]> => {
    const { user } = this.props;
    const eventIds = Lazy(people)
      .map(person => [
        ...(propz.get<any[]>(person, ['clashes', 'fullClashEvents'], []) || []),
        ...(propz.get<any[]>(person, ['clashes', 'intervalClashEvents'], []) || [])
      ])
      .flatten()
      .map((event: any) => String(event._id || event.id || ''))
      .filter((eventId: string) => eventId !== '' && !this.clashEventTitleCache.has(eventId))
      .uniq()
      .toArray();

    await Promise.all(
      eventIds.map(async eventId => {
        try {
          const event = await getSchoolEvent(user, eventId);
          this.clashEventTitleCache.set(eventId, getClashEventDisplayTitle(event, user));
        } catch (error) {
          // A missing/inaccessible clash event must not prevent the participant list from loading.
        }
      })
    );

    const hydrateEvents = (events: any[] = []) =>
      events.map(event => ({
        ...event,
        displayTitle: this.clashEventTitleCache.get(String(event._id || event.id || '')) || undefined,
        generatedName:
          event.generatedName || this.clashEventTitleCache.get(String(event._id || event.id || '')) || undefined
      }));

    return people.map(person => ({
      ...person,
      clashes: person.clashes
        ? {
            ...person.clashes,
            fullClashEvents: hydrateEvents(person.clashes.fullClashEvents),
            intervalClashEvents: hydrateEvents(person.clashes.intervalClashEvents)
          }
        : person.clashes
    }));
  };

  getTeamPlayersNormalized(teamPlayers: SchoolEventTeamPlayerWithClashes[]): Item[] {
    const sortedTeamPlayers = getPersonListSortedByName(teamPlayers);

    return sortedTeamPlayers.map(teamPlayer => {
      const { permissionId, form, gender, firstName, lastName, userId, id, house, clashes } = teamPlayer;
      return {
        permissionId,
        form,
        house,
        yearGroup:
          propz.get(teamPlayer, ['form', 'ageGroup'], '') ||
          propz.get(
            AGE_GROUPS,
            [this.props.user.activeSchool.ageGroupsNaming, propz.get(teamPlayer, ['form', 'age'])],
            ''
          ),
        gender,
        firstName,
        lastName,
        clashes: clashes,
        avatar:
          propz.get(teamPlayer, ['profile', 'avatar'], '') ||
          propz.get(teamPlayer, ['user', 'profile', 'avatar'], '') ||
          propz.get(teamPlayer, ['profileData', 'avatar'], '') ||
          propz.get(teamPlayer, ['picUrl'], ''),
        birthday: propz.get(teamPlayer, ['birthday'], ''),
        specialEducationNeeds: propz.get(teamPlayer, ['specialEducationNeeds'], false),
        pupilsPremium: propz.get(teamPlayer, ['pupilsPremium'], false),
        id: userId,
        playerId: id
      };
    });
  }

  getStudentsNormalized(students: SchoolStudentClash[]): Item[] {
    const sortedStudents = getPersonListSortedByName(students);

    return sortedStudents.map(student => {
      const { permissionId, form, gender, firstName, lastName, id, house, clashes } = student;

      return {
        permissionId,
        form,
        house,
        yearGroup:
          propz.get(student, ['form', 'ageGroup'], '') ||
          propz.get(
            AGE_GROUPS,
            [this.props.user.activeSchool.ageGroupsNaming, propz.get(student, ['form', 'age'])],
            ''
          ),
        gender,
        firstName,
        lastName,
        clashes,
        avatar:
          propz.get(student, ['profile', 'avatar'], '') ||
          propz.get(student, ['user', 'profile', 'avatar'], '') ||
          propz.get(student, ['profileData', 'avatar'], '') ||
          propz.get(student, ['picUrl'], ''),
        birthday: propz.get(student, ['birthday'], ''),
        specialEducationNeeds: propz.get(student, ['specialEducationNeeds'], false),
        pupilsPremium: propz.get(student, ['pupilsPremium'], false),
        id
      };
    });
  }

  getItemsFilter(page, itemsAccumulator, itemsAddBuffer, isAllItems = false) {
    const { itemsFilters, forms, event, itemsSearch } = this.state;

    if (!event) return null;

    const { startTime, endTime, id, players } = event;

    if (!startTime || !endTime) return null;

    const teamId = this.getTeamId();

    const {
      gender: itemsFiltersGender = [],
      ages: itemsFiltersAges = [],
      firstName: itemsFiltersFirstName = '',
      lastName: itemsFiltersLastName = '',
      forms: itemsFiltersForms = [],
      houses: itemsFiltersHouses = []
    } = itemsFilters;
    const birthdayFilter = itemsFilters.birthday || {};

    let where: any = { eventId: id };
    if (itemsFiltersGender.length > 0) where.gender = { $in: itemsFiltersGender };

    const playerUserIdsFromOtherTeams = players
      .filter(player => (player as any).teamId !== teamId)
      .map(player => ({ id: player.userId }));

    const allItems = [...itemsAccumulator, ...itemsAddBuffer, ...playerUserIdsFromOtherTeams];
    const ninIds = Lazy(allItems)
      .map(item => item.id)
      .uniq()
      .toArray();
    propz.set(where, ['_id', '$nin'], ninIds);

    if (itemsFiltersAges.length || itemsFiltersForms.length) {
      where.formId = { $in: participantFormIds(forms, itemsFiltersAges, itemsFiltersForms) };
    }

    if (isHousesEvent(event)) {
      const houseId = this.getHouseId();
      propz.set(where, ['houseId'], houseId);
    }

    if (!isHousesEvent(event) && itemsFiltersHouses.length > 0) {
      propz.set(where, ['houseId', '$in'], itemsFiltersHouses);
    }

    if (birthdayFilter.from || birthdayFilter.to) {
      where.birthday = {};
      if (birthdayFilter.from) {
        where.birthday.$gte = Moment(birthdayFilter.from, ['DD-MM-YYYY', 'YYYY-MM-DD'], true).toISOString();
      }
      if (birthdayFilter.to) {
        const birthdayTo = Moment(birthdayFilter.to, ['DD-MM-YYYY', 'YYYY-MM-DD'], true).toDate();
        birthdayTo.setHours(23, 59, 59, 999);
        where.birthday.$lte = birthdayTo.toISOString();
      }
    }
    if (itemsFilters.specialEducationNeeds === true) where.specialEducationNeeds = true;
    if (itemsFilters.pupilsPremium === true) where.pupilsPremium = true;

    let and: any[] = [];

    if (itemsFiltersFirstName.length > 0) {
      and.push({ firstName: { like: itemsFiltersFirstName, options: 'i' } });
    }

    if (itemsFiltersLastName.length > 0) {
      and.push({ lastName: { like: itemsFiltersLastName, options: 'i' } });
    }

    and.push(...participantNameConditions(itemsSearch));

    if (and.length > 0) {
      propz.set(where, ['$and'], and);
    }

    const startTimeDate = new Date(startTime);
    const startTimeCopy = new Date(startTime);
    startTimeCopy.setHours(startTimeDate.getHours() - 1);
    const intervalClashStartDate = Moment(startTimeCopy)
      .utc()
      .format();

    const endTimeDate = new Date(endTime);
    const endTimeCopy = new Date(endTime);
    endTimeCopy.setHours(endTimeDate.getHours() + 1);
    const intervalClashEndDate = Moment(endTimeCopy)
      .utc()
      .format();

    propz.set(where, ['intervalClashStartDate'], intervalClashStartDate);
    propz.set(where, ['intervalClashEndDate'], intervalClashEndDate);
    propz.set(where, ['fullClashStartDate'], startTime);
    propz.set(where, ['fullClashEndDate'], endTime);

    return {
      where,
      limit: isAllItems ? DEFAULT_LIMIT : LIMIT,
      skip: isAllItems ? 0 : (page - 1) * LIMIT,
      order: DEFAULT_TEAM_PLAYERS_ORDER
    };
  }

  getItemsAndItemsAccumulator() {
    const { user } = this.props;
    const { itemsAccumulatorFilters, forms } = this.state;

    const teamId = this.getTeamId();
    const eventId = this.getEventId();
    const isTeamIdExist = typeof teamId !== 'undefined';

    const options = { forms };
    const where = getServerFieldSectionWhere(itemsAccumulatorFilters, options);

    const getTeamPlayersPromise: Promise<SchoolEventTeamPlayerWithClashes[]> = isTeamIdExist
      ? getTeamPlayersMethod(user)(user, eventId, teamId, {}).then(this.hydrateClashEventTitles)
      : Promise.resolve([]);

    const getTeamPlayersCountPromise = isTeamIdExist
      ? getSchoolEventTeamPlayersCount(user, eventId, teamId, where)
      : Promise.resolve({ count: 0 });

    let teamPlayersInitial: SchoolEventTeamPlayerWithClashes[] = [];
    let teamPlayers: SchoolEventTeamPlayerWithClashes[] = [];
    let teamPlayersCount: any = { count: 0 };

    return Promise.all([getTeamPlayersPromise, getTeamPlayersCountPromise])
      .then(([_teamPlayers, _teamPlayersCount]) => {
        teamPlayersInitial = _teamPlayers || [];
        teamPlayers = _teamPlayers || [];
        teamPlayersCount = _teamPlayersCount || { count: 0 };

        const teamPlayersInitialNormalized = this.getTeamPlayersNormalized(teamPlayersInitial);

        const filter = this.getItemsFilter(1, teamPlayersInitialNormalized, []);

        const method = getStudentsMethod(user);
        const getStudentsPromise = method(user, filter).then(this.hydrateClashEventTitles);
        const getStudentsCountPromise = getSchoolStudentsWithClashesCount(user, filter);

        return Promise.all([getStudentsPromise, getStudentsCountPromise]);
      })
      .then(([students, studentsCount]) => {
        return {
          teamPlayersInitial,
          teamPlayers,
          teamPlayersCount,
          students,
          studentsCount
        };
      });
  }

  onItemClick = (index: number): void => {
    const { items, itemsSelected } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = itemsSelected.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...itemsSelected];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      itemsAccumulatorSelected: [],
      itemsSelected: selectedItemsUpdated
    });
  };

  onItemAccumulatorClick = (index: number): void => {
    const { itemsAccumulator, itemsAccumulatorSelected } = this.state;
    const selectedItem = itemsAccumulator[index];

    const selectedItemIndex = itemsAccumulatorSelected.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...itemsAccumulatorSelected];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      itemsAccumulatorSelected: selectedItemsUpdated,
      itemsSelected: []
    });
  };

  onAddClick = () => {
    const {
      itemsSelected,
      itemsAddBuffer,
      itemsAccumulatorInitial,
      itemsAccumulator,
      itemCurrentPage,
      event
    } = this.state;
    const { user } = this.props;

    if (event && isTournamentEvent(event)) {
      const maxPlayers = propz.get(event, ['sport', 'defaultLimits', 'maxPlayers']);
      if (typeof maxPlayers === 'number' && maxPlayers > 0) {
        const currentCount = itemsAccumulator.length;
        const tryingToAdd = itemsSelected.length;
        if (currentCount + tryingToAdd > maxPlayers) {
          this.setState({
            isMaxPlayersModalOpen: true,
            maxPlayersModalMessage: `Player limit reached: you can have maximum ${maxPlayers} participant(s) per school. Currently ${currentCount} selected, trying to add ${tryingToAdd}.`
          });
          return;
        }
      }
    }

    const nextItemsAddBuffer = [...itemsAddBuffer, ...itemsSelected];

    const existingIds = new Set((itemsAccumulator || []).map(x => String(x.id)));
    const nextItemsAccumulator = [...itemsAccumulator, ...itemsSelected.filter(x => !existingIds.has(String(x.id)))];

    const addedIds = new Set(itemsSelected.map(item => String(item.id)));
    this.setState({
      items: this.state.items.filter(item => !addedIds.has(String(item.id))),
      itemsAddBuffer: nextItemsAddBuffer,
      itemsAccumulator: nextItemsAccumulator,
      itemsAccumulatorCount: nextItemsAccumulator.length,
      itemsAccumulatorSelected: [],
      itemsSelected: [],
      isSelectAllItemsAccumulatorChecked: false,
      isSelectAllItemsChecked: false
    });

    const filter = this.getItemsFilter(itemCurrentPage, itemsAccumulatorInitial, nextItemsAddBuffer);
    const method = getStudentsMethod(user);
    const getStudentsPromise = method(user, filter).then(this.hydrateClashEventTitles);
    const getStudentsCountPromise = getSchoolStudentsWithClashesCount(user, filter);

    Promise.all([getStudentsPromise, getStudentsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized(students);

      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: studentsCount.count
      });
    });
  };

  onRemoveClick = () => {
    const {
      itemsAccumulatorSelected,
      itemsAddBuffer,
      itemsRemoveBuffer,
      itemsAccumulatorInitial,
      itemsAccumulator,
      itemCurrentPage
    } = this.state;
    const { user } = this.props;

    const selectedIds = new Set((itemsAccumulatorSelected || []).map(x => String(x.id)));
    const addBufferIds = new Set((itemsAddBuffer || []).map(x => String(x.id)));

    const selectedExistingParticipants = (itemsAccumulatorSelected || []).filter(x => !addBufferIds.has(String(x.id)));

    const nextItemsAddBuffer = (itemsAddBuffer || []).filter(x => !selectedIds.has(String(x.id)));

    const existingRemoveIds = new Set((itemsRemoveBuffer || []).map(x => String(x.id)));
    const nextItemsRemoveBuffer = [
      ...(itemsRemoveBuffer || []),
      ...selectedExistingParticipants.filter(x => !existingRemoveIds.has(String(x.id)))
    ];

    const nextItemsAccumulatorInitial = (itemsAccumulatorInitial || []).filter(
      itemAccumulatorInitial =>
        !nextItemsRemoveBuffer.some(
          nextItemRemoveBuffer => String(nextItemRemoveBuffer.id) === String(itemAccumulatorInitial.id)
        )
    );

    const nextItemsAccumulator = (itemsAccumulator || []).filter(
      itemAccumulator => !selectedIds.has(String(itemAccumulator.id))
    );

    const restoredItems = (itemsAccumulatorSelected || []).filter(
      removed => !this.state.items.some(item => String(item.id) === String(removed.id))
    );
    this.setState({
      items: [...restoredItems, ...this.state.items],
      itemsAccumulator: nextItemsAccumulator,
      itemsAccumulatorCount: nextItemsAccumulator.length,
      itemsAccumulatorSelected: [],
      itemsSelected: [],
      isSelectAllItemsAccumulatorChecked: false,
      isSelectAllItemsChecked: false,
      itemsAddBuffer: nextItemsAddBuffer,
      itemsRemoveBuffer: nextItemsRemoveBuffer,
      itemsAccumulatorInitial: nextItemsAccumulatorInitial
    });

    const filter = this.getItemsFilter(itemCurrentPage, nextItemsAccumulatorInitial, nextItemsAddBuffer);
    const method = getStudentsMethod(user);
    const getStudentsPromise = method(user, filter).then(this.hydrateClashEventTitles);
    const getStudentsCountPromise = getSchoolStudentsWithClashesCount(user, filter);

    Promise.all([getStudentsPromise, getStudentsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized(students);

      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: studentsCount.count
      });
    });
  };

  getTeam() {
    const { user } = this.props;
    const { teamName, event } = this.state;

    if (!event) return null;

    const { activeSchoolId } = user;
    const { ages, gender, sportId } = event;
    const houseId = this.getHouseId();

    return isHousesEvent(event)
      ? {
          ages: ages.map(age => Number(age)),
          gender: gender,
          name: teamName,
          schoolId: activeSchoolId,
          sportId: sportId,
          teamType: TEAM_TYPE.ADHOC,
          houseId: houseId
        }
      : {
          ages: ages.map(age => Number(age)),
          gender: gender,
          name: teamName,
          schoolId: activeSchoolId,
          sportId: sportId,
          teamType: TEAM_TYPE.ADHOC
        };
  }

  showFollowingEventsSection = () => {
    this.setState({
      isShowFollowingEventsSection: true
    });
  };

  onEditModeClick = editMode => {
    this.setState({
      editMode: editMode
    });
  };

  onClickSave = () => {
    const {
      itemsAddBuffer,
      itemsRemoveBuffer,
      teamName,
      event,
      editMode,
      isShowFollowingEventsSection,
      itemsAccumulator,
      tournamentTeams,
      team
    } = this.state;

    if (!event) return;

    const { user, history } = this.props;
    const { activeSchoolId } = user;
    const clubId = (event as any).clubId;
    const groupEditMode = editMode === CLUB_EVENT_EDIT_MODE.GROUP;
    const eventId = this.getEventId();
    const schoolsScores = propz.get(event, ['results', 'schoolScore'], []);
    const activeSchoolScore = schoolsScores.find(score => score.schoolId === activeSchoolId);
    const isScoreExist = typeof activeSchoolScore !== 'undefined';

    switch (true) {
      case isClubEvent(event) && !isShowFollowingEventsSection:
        this.showFollowingEventsSection();

        break;

      case isClubEvent(event) && groupEditMode: {
        this.setState({
          isLoading: true
        });

        const playersCommit = itemsAccumulator.map(player => {
          return {
            userId: player.id,
            permissionId: player.permissionId
          };
        });

        const teamPromise = isClubEvent(event)
          ? Promise.all([
              getAllClubParticipants(user, clubId),
              updateSchoolEventIndividualsGroupBatch(user, eventId, { participants: playersCommit })
            ])
          : updateSchoolEventIndividualsGroupBatch(user, eventId, { participants: playersCommit });

        teamPromise
          .then(response => {
            if (isClubEvent(event)) {
              const [participants] = response;

              const studentsAreNotClubParticipants = itemsAddBuffer.filter(item => {
                return !participants.some(participant => {
                  return participant.userId === item.id;
                });
              });

              const isStudentsAreNotClubParticipantsExist = studentsAreNotClubParticipants.length > 0;

              if (isStudentsAreNotClubParticipantsExist) {
                const studentToAddData = {
                  syncUpcomingEvents: false,
                  participants: studentsAreNotClubParticipants.map(student => {
                    return {
                      userId: student.id,
                      permissionId: student.permissionId
                    };
                  })
                };

                return addClubStudents(user, clubId, studentToAddData);
              }

              return Promise.resolve();
            }
          })
          .then(() => {
            history.push({
              pathname: '/events/event',
              search: `id=${eventId}`
            });
          })
          .catch(this.onSaveError);

        break;
      }

      case isTournamentEvent(event): {
        this.setState({
          isLoading: true
        });

        const { tournamentId } = event as any;

        const teamId = this.getTeamId();
        const currentSchoolTeam = tournamentTeams.find(item => {
          return item.schoolId === activeSchoolId;
        });
        const isCurrentSchoolTeamExist = typeof currentSchoolTeam !== 'undefined';

        const tournamentTeamsPlayers = propz.get(currentSchoolTeam, ['players'], []);
        const tournamentTeamsPlayersIds = tournamentTeamsPlayers.map(player => player.userId);

        const studentsToAddToTeam = itemsAddBuffer.filter(item => !tournamentTeamsPlayersIds.includes(item.id));
        const isStudentsToAddToTeamExist = studentsToAddToTeam.length > 0;

        const data = {
          add: itemsAddBuffer.map(item => ({ userId: item.id, permissionId: item.permissionId })),
          remove: itemsRemoveBuffer.map(item => item.playerId).filter((id): id is string => typeof id === 'string')
        };

        const isTeamExist = typeof teamId !== 'undefined';
        const team = this.getTeam();
        const teamPromise = isTeamExist ? Promise.resolve(undefined) : addSchoolEventTeam(user, eventId, team);

        teamPromise
          .then(addTeam =>
            isTeamExist
              ? updateSchoolEventTeamPlayersBatch(user, eventId, teamId, data)
              : updateSchoolEventTeamPlayersBatch(user, eventId, addTeam.id, data)
          )
          .then(() => {
            switch (true) {
              case isCurrentSchoolTeamExist:
                if (isStudentsToAddToTeamExist) {
                  const addToTeamData = {
                    add: studentsToAddToTeam.map(item => ({ userId: item.id, permissionId: item.permissionId })),
                    remove: []
                  };

                  return updateSchoolTournamentTeamPlayersBatch(
                    user,
                    tournamentId,
                    currentSchoolTeam.id,
                    addToTeamData
                  );
                }

                break;

              case !isCurrentSchoolTeamExist:
                return this.createDefaultTournamentTeam();
            }
          })
          .then(newTeam => {
            if (!isCurrentSchoolTeamExist) {
              const addToTeamData = {
                add: studentsToAddToTeam.map(item => ({ userId: item.id, permissionId: item.permissionId })),
                remove: []
              };

              return updateSchoolTournamentTeamPlayersBatch(user, tournamentId, newTeam.id, addToTeamData);
            }
          })
          .then(() => {
            history.push({
              pathname: '/events/event',
              search: `id=${eventId}`
            });
          })
          .catch(this.onSaveError);

        break;
      }

      case isClubEvent(event) || teamName !== '': {
        this.setState({
          isLoading: true
        });

        const teamId = this.getTeamId();
        const data = {
          add: itemsAddBuffer.map(item => ({ userId: item.id, permissionId: item.permissionId })),
          remove: itemsRemoveBuffer.map(item => item.playerId).filter((id): id is string => typeof id === 'string')
        };

        const isTeamExist = typeof teamId !== 'undefined';
        const team = this.getTeam();
        const teamPromise = isTeamExist
          ? updateSchoolEventTeam(user, eventId, teamId, team)
          : addSchoolEventTeam(user, eventId, team);

        let addTeam;

        teamPromise
          .then(_addTeam => {
            addTeam = _addTeam;

            const updateSchoolEventTeamPlayersPromise = isTeamExist
              ? updateSchoolEventTeamPlayersBatch(user, eventId, teamId, data)
              : updateSchoolEventTeamPlayersBatch(user, eventId, addTeam.id, data);

            return isClubEvent(event)
              ? Promise.all([getAllClubParticipants(user, clubId), updateSchoolEventTeamPlayersPromise])
              : updateSchoolEventTeamPlayersPromise;
          })
          .then(response => {
            if (isClubEvent(event)) {
              const [participants] = response;

              const studentsAreNotClubParticipants = itemsAddBuffer.filter(item => {
                const isSelectedStudentClubParticipant = participants.some(participant => {
                  return participant.userId === item.id;
                });

                return !isSelectedStudentClubParticipant;
              });

              const isStudentsAreNotClubParticipantsExist = studentsAreNotClubParticipants.length > 0;

              if (isStudentsAreNotClubParticipantsExist) {
                const studentToAddData = {
                  syncUpcomingEvents: false,
                  participants: studentsAreNotClubParticipants.map(student => {
                    return {
                      userId: student.id,
                      permissionId: student.permissionId
                    };
                  })
                };

                return addClubStudents(user, clubId, studentToAddData);
              }
            }
          })
          .then(() => {
            if (!isTeamExist && isScoreExist) {
              const { id } = event;
              const score = {
                score: activeSchoolScore.score,
                teamId: addTeam.id
              };

              return createTeamScore(user, id, score);
            }
          })
          .then(() => {
            history.push({
              pathname: '/events/event',
              search: `id=${eventId}`
            });
          })
          .catch(this.onSaveError);

        break;
      }

      default:
        this.setState({
          isError: true
        });

        break;
    }
  };

  onSaveError = (error: any) => {
    const isClub = Boolean(this.state.event && isClubEvent(this.state.event));
    const message =
      propz.get(error, ['response', 'data', 'details', 'text']) ||
      propz.get(error, ['response', 'data', 'message']) ||
      propz.get(error, ['message']) ||
      `The ${isClub ? 'participants' : 'squad'} could not be saved. Please try again.`;

    this.setState({
      isLoading: false,
      saveErrorMessage: String(message)
    });
  };

  closeSaveErrorModal = () => {
    this.setState({ saveErrorMessage: '' });
  };

  createDefaultTournamentTeam = () => {
    const { user } = this.props;
    const { event } = this.state;
    const { activeSchoolId: schoolId } = user;
    const { tournament, tournamentId } = event;
    const { gender, ages, sportId } = tournament;
    const tournamentName = propz.get(tournament, ['name'], '');
    const schoolName = propz.get(user, ['activeSchoolName'], '');
    const name = `${schoolName} ${tournamentName}`;

    const teamData = {
      name,
      ages,
      gender,
      sportId,
      schoolId,
      teamType: TEAM_TYPE.ADHOC,
      isAutoEnrolledTeam: true,
      players: []
    };

    return addSchoolTournamentTeam(user, tournamentId, teamData);
  };

  onItemsFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.itemsFilters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (filterField === 'forms') {
      nextFilters.ages = [];
    }

    if (filterField === 'ages') {
      nextFilters.forms = [];
    }

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      if (filterField === 'specialEducationNeeds' || filterField === 'pupilsPremium') {
        this.setState({ itemsFilters: { ...nextFilters, [filterField]: Boolean(filterValue) } });
        return;
      }
      const filter = ITEMS_COLUMNS.find(col => col.field === filterField);
      if (!filter) return;
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      itemsFilters: nextFilters
    });
  };

  onItemsAccumulatorFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.itemsAccumulatorFilters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = ITEMS_COLUMNS.find(col => col.field === filterField);
      if (!filter) return;
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      itemsAccumulatorFilters: nextFilters
    });
  };

  onItemsFilterClick = (event): void => {
    event.preventDefault();

    const { isShowItemsFilter } = this.state;

    this.setState({
      isShowItemsFilter: !isShowItemsFilter
    });
  };

  onItemsAccumulatorFilterClick = (event): void => {
    event.preventDefault();

    const { isShowItemsAccumulatorFilter } = this.state;

    this.setState({
      isShowItemsAccumulatorFilter: !isShowItemsAccumulatorFilter
    });
  };

  itemsSetCurrentPageParams = (currentPage: number): void => {
    const { user } = this.props;
    const { itemsAccumulator, itemsAddBuffer } = this.state;
    const requestId = ++this.itemsSearchRequestId;

    this.setState({ isItemsLoading: true });

    const filter = this.getItemsFilter(currentPage, itemsAccumulator, itemsAddBuffer);

    const method = getStudentsMethod(user);

    method(user, filter)
      .then(this.hydrateClashEventTitles)
      .then(students => {
        if (requestId !== this.itemsSearchRequestId) return;
        const studentsNormalized = this.getStudentsNormalized(students);

        this.setState({
          itemCurrentPage: currentPage,
          items: studentsNormalized,
          isItemsLoading: false
        });
      })
      .catch(error => {
        if (requestId === this.itemsSearchRequestId) {
          this.setState({ isItemsLoading: false });
        }
        throw error;
      });
  };

  itemsOnApplyFilterClick = (isSilent = false) => {
    const { itemsAccumulator, itemsAddBuffer } = this.state;
    const requestId = ++this.itemsSearchRequestId;

    if (isSilent) this.setState({ isItemsLoading: true });
    else this.setState({ isLoading: true });

    const filter = this.getItemsFilter(1, itemsAccumulator, itemsAddBuffer);

    const { user } = this.props;

    const method = getStudentsMethod(user);
    const getStudentsPromise = method(user, filter).then(this.hydrateClashEventTitles);
    const getStudentCountPromise = getSchoolStudentsWithClashesCount(user, filter);

    Promise.all([getStudentsPromise, getStudentCountPromise]).then(([students, studentsCount]) => {
      if (requestId !== this.itemsSearchRequestId) return;
      const studentsNormalized = this.getStudentsNormalized(students);

      this.setState({
        items: studentsNormalized,
        isLoading: isSilent ? this.state.isLoading : false,
        isItemsLoading: false,
        itemsCount: studentsCount.count,
        itemsAccumulatorSelected: isSilent ? this.state.itemsAccumulatorSelected : [],
        itemsSelected: isSilent ? this.state.itemsSelected : [],
        itemCurrentPage: 1,
        sortItemsDirection: '' as TABLE_SORT_DIRECTION,
        sortItemsColumnsName: ''
      });
    });
  };

  onReplaceItemsFilters = (filters: any) => {
    this.setState({ itemsFilters: filters }, this.itemsOnApplyFilterClick);
  };

  onItemsSearchChange = (itemsSearch: string) => {
    this.setState({ itemsSearch, isItemsLoading: true }, () => this.itemsOnApplyFilterClick(true));
  };

  itemsAccumulatorOnApplyFilterClick = () => {};
  // itemsAccumulatorOnApplyFilterClick = () => {
  //   const { itemsAccumulatorFilters, itemsRemoveBuffer, forms } = this.state;
  //   this.setState({
  //     isLoading: true
  //   });
  //
  //   const options = { forms };
  //
  //   let where = getServerFieldSectionWhere(itemsAccumulatorFilters, options);
  //   const ninIds = itemsRemoveBuffer.map(item => item.id);
  //   propz.set(where, ['id', '$nin'], ninIds);
  //
  //   const { user } = this.props;
  //
  //   const teamId = this.getTeamId();
  //   const eventId = this.getEventId();
  //
  //   const getTeamPlayersPromise = getAllSchoolEventTeamPlayers(user, eventId, teamId, where);
  //   const getTeamPlayersCountPromise = getSchoolEventTeamPlayersCount(user, eventId, teamId, where);
  //
  //   BPromise.all([getTeamPlayersPromise, getTeamPlayersCountPromise]).then(([teamPlayers, teamPlayersCount]) => {
  //     const teamPlayersNormalized = this.getTeamPlayersNormalized(teamPlayers);
  //
  //     this.setState({
  //       itemsAccumulator: teamPlayersNormalized,
  //       isLoading: false,
  //       itemsAccumulatorCount: teamPlayersCount.count,
  //       itemsAccumulatorSelected: [],
  //       itemsSelected: []
  //     });
  //   });
  // };

  itemsOnClearFilterClick = () => {
    this.setState(
      {
        itemsFilters: {
          firstName: '',
          lastName: '',
          gender: [],
          forms: [],
          houses: [],
          ages: [],
          birthday: {},
          specialEducationNeeds: false,
          pupilsPremium: false
        },
        isItemsFiltered: false
      },
      this.itemsOnApplyFilterClick
    );
  };

  itemsAccumulatorOnClearFilterClick = () => {};
  // itemsAccumulatorOnClearFilterClick = () => {
  //   this.setState({
  //     isLoading: true
  //   });
  //
  //   const { user } = this.props;
  //   const teamId = this.getTeamId();
  //   const { itemsRemoveBuffer } = this.state;
  //
  //   const eventId = this.getEventId();
  //
  //   const getTeamPlayersPromise = getAllSchoolEventTeamPlayers(user, eventId, teamId);
  //   const getTeamPlayersCountPromise = getSchoolEventTeamPlayersCount(user, eventId, teamId);
  //
  //   BPromise.all([getTeamPlayersPromise, getTeamPlayersCountPromise]).then(([teamPlayers, teamPlayersCount]) => {
  //     const teamPlayersNormalized = this.getTeamPlayersNormalized(teamPlayers);
  //     const nextTeamPlayersNormalized = teamPlayersNormalized.filter(teamPlayerNormalized =>
  //       itemsRemoveBuffer.every(item => item.id !== teamPlayerNormalized.id)
  //     );
  //
  //     this.setState({
  //       itemsAccumulator: nextTeamPlayersNormalized,
  //       isLoading: false,
  //       itemsAccumulatorCount: teamPlayersCount.count,
  //       itemsAccumulatorSelected: [],
  //       itemsSelected: [],
  //       itemsAccumulatorFilters: {}
  //     });
  //   });
  // };

  onSelectAllItemsClick = () => {
    const { itemsSelected, itemCurrentPage, itemsAccumulator, itemsAddBuffer } = this.state;

    this.setState({
      isLoading: true,
      isSelectingAll: true,
      selectionError: ''
    });

    const { user } = this.props;

    const filter = this.getItemsFilter(itemCurrentPage, itemsAccumulator, itemsAddBuffer, true);

    return allParticipantPages(
      filter => getStudentsMethod(user)(user, filter),
      filter,
      Math.max(LIMIT, this.state.itemsCount + 1)
    )
      .then(items => {
        const itemsFiltered = items.filter(item => {
          return itemsSelected.every(selectedItem => selectedItem.id !== item.id);
        });

        const studentsNormalizedFiltered = this.getStudentsNormalized(itemsFiltered);

        const nextSelectedItems = [...itemsSelected, ...studentsNormalizedFiltered];

        this.setState({
          itemsSelected: nextSelectedItems,
          isSelectAllItemsChecked: true,
          itemsAccumulatorSelected: [],
          isSelectAllItemsAccumulatorChecked: false,
          isSelectingAll: false,
          isLoading: false
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          isSelectingAll: false,
          selectionError: 'Students could not be selected. Please try again.'
        });
      });
  };

  onSelectAllFilteredItemsClick = () => {
    const { itemCurrentPage, itemsAccumulator, itemsAddBuffer } = this.state;
    this.setState({ isLoading: true, isSelectingAll: true, selectionError: '' });
    const filter = this.getItemsFilter(itemCurrentPage, itemsAccumulator, itemsAddBuffer, true);
    return allParticipantPages(
      filter => getStudentsMethod(this.props.user)(this.props.user, filter),
      filter,
      Math.max(LIMIT, this.state.itemsCount + 1)
    )
      .then(items => {
        const normalizedItems = this.getStudentsNormalized(items);
        const selectedIds = new Set(this.state.itemsSelected.map(item => String(item.id)));
        this.setState({
          itemsSelected: [
            ...this.state.itemsSelected,
            ...normalizedItems.filter(item => !selectedIds.has(String(item.id)))
          ],
          isSelectAllItemsChecked: true,
          itemsAccumulatorSelected: [],
          isSelectAllItemsAccumulatorChecked: false,
          isSelectingAll: false,
          isLoading: false
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          isSelectingAll: false,
          selectionError: 'Students could not be selected. Please try again.'
        });
      });
  };

  onSelectAllItemsOnPageClick = () => {
    const { items, itemsSelected } = this.state;

    const itemsFiltered = items.filter(item => {
      return itemsSelected.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...itemsSelected, ...itemsFiltered];

    this.setState({
      itemsSelected: nextSelectedItems,
      isSelectAllItemsChecked: true,
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false
    });
  };

  onUnselectAllItemsClick = () => {
    this.setState({
      itemsSelected: [],
      isSelectAllItemsChecked: false,
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false
    });
  };

  onSelectAllItemsAccumulatorClick = () => {
    this.onSelectAllItemsAccumulatorOnPageClick();
  };

  onSelectAllItemsAccumulatorOnPageClick = () => {
    const { itemsAccumulator, itemsAccumulatorSelected, itemsRemoveBuffer } = this.state;

    const itemsFiltered = itemsAccumulator.filter(item => {
      return itemsAccumulatorSelected.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...itemsAccumulatorSelected, ...itemsFiltered].filter(item => {
      return itemsRemoveBuffer.every(itemRemoveBuffer => itemRemoveBuffer.id !== item.id);
    });

    this.setState({
      itemsAccumulatorSelected: nextSelectedItems,
      isSelectAllItemsAccumulatorChecked: true,
      itemsSelected: [],
      isSelectAllItemsChecked: false
    });
  };

  onUnselectAllItemsAccumulatorClick = () => {
    this.setState({
      itemsAccumulatorSelected: [],
      isSelectAllItemsAccumulatorChecked: false,
      itemsSelected: [],
      isSelectAllItemsChecked: false
    });
  };

  onSortItemsClick = (sortField: string) => {
    const { sortItemsDirection, sortItemsColumnsName, itemCurrentPage, itemsAccumulator, itemsAddBuffer } = this.state;

    const order = getOrder(sortField, sortItemsDirection, sortItemsColumnsName) as TABLE_SORT_DIRECTION;

    const filter = this.getItemsFilter(itemCurrentPage, itemsAccumulator, itemsAddBuffer);
    const { user } = this.props;

    const method = getStudentsMethod(user);
    const getStudentsPromise = method(user, filter).then(this.hydrateClashEventTitles);
    const getSchoolsCountPromise = getSchoolStudentsWithClashesCount(user, filter);

    Promise.all([getStudentsPromise, getSchoolsCountPromise]).then(([students, studentsCount]) => {
      const studentsNormalized = this.getStudentsNormalized(students);

      this.setState({
        items: studentsNormalized,
        isLoading: false,
        itemsCount: studentsCount.count,
        itemsAccumulatorSelected: [],
        itemsSelected: [],
        itemCurrentPage: 1,
        sortItemsColumnsName: sortField,
        sortItemsDirection: order
      });
    });
  };

  onSortItemsAccumulatorClick = (sortField: string) => {};

  onChangeTeamName = event => {
    const teamName = event.target.value;

    this.setState({
      teamName
    });
  };

  goBack = () => {
    const { event } = this.state;
    const { history } = this.props;
    const eventId = event.id;
    history.push({
      pathname: '/events/event',
      search: `id=${eventId}`
    });
  };

  renderExitConfirmationModal = () => {
    const { isExitConfirmationModalOpen } = this.state;

    return (
      <SimpleModal isOpen={isExitConfirmationModalOpen} title={'Confirm the action'}>
        <div>You haven’t saved your team, are you sure you want to leave this page?</div>
        <div>
          <Button onClick={this.closeExitConfirmationModal} text={'Cancel'} customClass={'btn-secondary mt-3 mr-3'} />
          <Button onClick={this.goBack} text={'Ok'} customClass={'mt-3'} />
        </div>
      </SimpleModal>
    );
  };

  openExitConfirmationModal = () => {
    this.setState({
      isExitConfirmationModalOpen: true
    });
  };

  closeExitConfirmationModal = () => {
    this.setState({
      isExitConfirmationModalOpen: false
    });
  };

  goBackWithOrWithoutConfirmation = () => {
    const { itemsAddBuffer, itemsRemoveBuffer } = this.state;
    const isChangesInTeamExist = itemsAddBuffer.length > 0 || itemsRemoveBuffer.length > 0;

    isChangesInTeamExist ? this.openExitConfirmationModal() : this.goBack();
  };

  onClashClick = (student: SchoolStudentClash | SchoolEventTeamPlayerWithClashes) => {
    const { user } = this.props;
    const { clashes, firstName, lastName } = student;
    const { fullClashEvents = [], intervalClashEvents = [] } = clashes || {};
    const fullClashEventIds = fullClashEvents.map(fullClashEvent => fullClashEvent._id);
    const intervalClashEventIds = intervalClashEvents.map(intervalClashEvent => intervalClashEvent._id);

    const allPlayerEventIds = [...fullClashEventIds, ...intervalClashEventIds];
    const allPlayerEventIdsUniq = Lazy(allPlayerEventIds)
      .uniq()
      .toArray();

    this.setState({
      isLoading: true
    });

    const eventsPromise: Promise<SchoolEvent>[] = allPlayerEventIdsUniq.map(eventId => getSchoolEvent(user, eventId));

    Promise.all(eventsPromise)
      .then(events => {
        this.setState({
          isStudentClashLoading: false,
          studentClashEvents: events.map(event => ({
            id: event.id,
            title: getClashEventDisplayTitle(event, user),
            type: fullClashEventIds.map(String).includes(String(event.id)) ? 'full' : 'interval'
          }))
        });
      })
      .catch(() => this.setState({ isStudentClashLoading: false }));
  };

  onCloseStudentEventsModalClick = () => {
    this.setState({
      isStudentEventsModalOpen: false,
      isStudentClashLoading: false
    });
  };

  onCloseMaxPlayersModal = () => {
    this.setState({ isMaxPlayersModalOpen: false, maxPlayersModalMessage: '' });
  };

  renderStudentEventsModal(): React.ReactNode {
    const { isStudentEventsModalOpen, isStudentClashLoading, studentClashStudentName, studentClashEvents } = this.state;
    return (
      <SimpleModal
        isOpen={isStudentEventsModalOpen}
        title="Schedule clash"
        onCloseClick={this.onCloseStudentEventsModalClick}
        onBackdropClick={this.onCloseStudentEventsModalClick}
        showFooter={false}
        isBodyBold={false}
        customClass="teamManagerClashModal"
        dialogStyle={{ maxWidth: 620 }}
      >
        <div className="teamManagerClashModal__body">
          <div className="teamManagerClashModal__intro">
            <span className="teamManagerClashModal__icon" aria-hidden="true">
              <i className="is-red" />
              <i className="is-amber" />
              <i className="is-green" />
            </span>
            <div>
              <strong>{studentClashStudentName}</strong>
              <p>Review the other events before adding this student to the team.</p>
            </div>
          </div>

          {isStudentClashLoading ? (
            <div className="teamManagerClashModal__loading">Loading conflicting events…</div>
          ) : studentClashEvents.length ? (
            <div className="teamManagerClashModal__events">
              {studentClashEvents.map(event => (
                <div className={`teamManagerClashModal__event is-${event.type}`} key={event.id}>
                  <span className="teamManagerClashModal__dot" aria-hidden="true" />
                  <div>
                    <strong>{event.title}</strong>
                    <span>{event.type === 'full' ? 'Direct overlap' : 'Close to this event'}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="teamManagerClashModal__empty">The conflicting event details could not be loaded.</div>
          )}

          <div className="teamManagerClashModal__actions">
            <button type="button" onClick={this.onCloseStudentEventsModalClick}>
              Close
            </button>
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderMaxPlayersModal(): React.ReactNode {
    const { isMaxPlayersModalOpen, maxPlayersModalMessage } = this.state;
    return (
      <StatusModal
        isOpen={isMaxPlayersModalOpen}
        status="warning"
        title="Player limit reached"
        message={maxPlayersModalMessage}
        onClose={this.onCloseMaxPlayersModal}
      />
    );
  }

  renderSaveErrorModal(): React.ReactNode {
    const { saveErrorMessage, event } = this.state;
    return (
      <StatusModal
        isOpen={saveErrorMessage !== ''}
        status="warning"
        title={event && isClubEvent(event) ? 'Participants not saved' : 'Squad not saved'}
        message={saveErrorMessage}
        onClose={this.closeSaveErrorModal}
      />
    );
  }

  openHelpModal = () => {
    this.setState({
      isHelpModalOpen: true
    });
  };

  closeHelpModal = () => {
    this.setState({
      isHelpModalOpen: false
    });
  };

  renderHelpModal(): React.ReactNode {
    const { isHelpModalOpen, event } = this.state;

    const maxPlayers =
      event && isTournamentEvent(event) ? propz.get(event, ['sport', 'defaultLimits', 'maxPlayers']) : null;
    const hasLimit = typeof maxPlayers === 'number' && maxPlayers > 0;

    return (
      <HelpModal
        isOpen={isHelpModalOpen}
        title="Manage team participants"
        badgeText="Step 2"
        subtitle="Find eligible students, stage the team changes and save when the participant list is ready."
        onClose={() => this.setState({ isHelpModalOpen: false })}
      >
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Event summary</div>
              <div className="text-muted">
                Check the sport, gender, age group, date and time at the top to make sure you are updating the correct
                event.
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Team setup</div>
              <div className="text-muted">
                Some events require a team name. Enter it in the required field below the event date. For house events,
                the assigned house is shown instead.
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Eligible students</div>
              <div className="text-muted">
                The left panel contains students who are eligible for this event and are not already selected for
                another team in it.
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Search and filters</div>
              <div className="text-muted">
                Search eligible students by name or surname. Results update quietly after you pause typing. Use filters
                for house, form, gender, age and other details; useful filter combinations can be saved as templates.
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Select and move</div>
              <div className="text-muted">
                Click a row or its checkbox to select it. Select all only ticks the matching students—it does not move
                them. Use the centre arrow to move selected rows, or double-click one row to move it immediately.
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Current participants</div>
              <div className="text-muted">
                The right panel shows the staged participant list. Search it by name, surname, registration form, house
                or year group. Move selected students back to the left to remove them from the team.
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Clashes</div>
              <div className="text-muted">
                When clash checking is enabled, the coloured indicator shows whether a student is free, has a nearby
                event or has a direct overlap. Open a non-green indicator to review the conflicting event.
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Save or leave</div>
              <div className="text-muted">
                Moves are staged in this screen and do not update the event immediately. Click Save to apply them. If
                you leave with unsaved changes, you will be asked to confirm.
              </div>
            </div>
          </div>

          {hasLimit && (
            <div className="col-md-6 mb-3">
              <div className="border rounded p-3 h-100">
                <div className="font-weight-bold mb-2">Participant limit</div>
                <div className="text-muted">
                  This sport has a maximum of <strong>{maxPlayers}</strong> participants per school. You will not be
                  able to add more than this number to the event.
                </div>
              </div>
            </div>
          )}
        </div>
      </HelpModal>
    );
  }

  render() {
    const {
      items,
      isLoading,
      itemsSelected,
      itemsAccumulatorSelected,
      itemsAccumulator,
      itemsFilters,
      isShowItemsFilter,
      isItemsFiltered,
      itemsCount,
      itemsAccumulatorCount,
      itemCurrentPage,
      itemsAccumulatorFilters,
      isShowItemsAccumulatorFilter,
      isItemsAccumulatorFiltered,
      isSelectAllItemsChecked,
      isSelectAllItemsAccumulatorChecked,
      sortItemsDirection,
      sortItemsColumnsName,
      sortItemsAccumulatorDirection,
      sortItemsAccumulatorColumnsName,
      itemsAddBuffer,
      itemsRemoveBuffer,
      forms,
      houses,
      event,
      teamName,
      isError,
      isShowFollowingEventsSection,
      editMode,
      isStudentEventsModalOpen,
      itemsHiddenFields,
      itemsAccumulatorHiddenFields,
      isItemsLoading
    } = this.state;

    if (isLoading) {
      return <Loader message={this.state.isSelectingAll ? 'Selecting all eligible students…' : undefined} />;
    }

    const { user } = this.props;
    const { activeSchool } = user;
    const { ageGroupsNaming, isShowStudentEventClashes } = activeSchool;

    const allItemsColumns = isShowStudentEventClashes ? ITEMS_COLUMNS_WITH_CLASHES : ITEMS_COLUMNS;
    const allAccumulatorColumns = isShowStudentEventClashes
      ? ITEMS_ACCUMULATOR_COLUMNS_WITH_CLASHES
      : ITEMS_ACCUMULATOR_COLUMNS;
    const visibleItemsColumns = allItemsColumns.filter(col => !itemsHiddenFields.has(col.field));
    const visibleAccumulatorColumns = allAccumulatorColumns.filter(col => !itemsAccumulatorHiddenFields.has(col.field));

    const itemsFiltersOptions = {
      ages: getSelectOptionForAge(forms, ageGroupsNaming),
      gender: getSelectOptionForGender(),
      forms: getSelectOptionForForms(forms),
      houses: getSelectOptionForHouses(houses)
    };
    const eventGenderPreset = getUserGenderArrayConvertedFromEventGender(event.gender);
    const itemsPresetFilters = {
      ages: (event.ages || []).map(age => String(age)),
      gender: eventGenderPreset.length === 1 ? eventGenderPreset.map(String) : []
    };

    const itemsAccumulatorFiltersOptions = {};

    const houseId = this.getHouseId();
    const house = event.housesData.find(eventHouse => eventHouse.id === houseId);
    const isShowTeamName = isTeamOrTwoOnTwoSportEvent(event) && !isClubEvent(event) && !isTournamentEvent(event);

    const eventStartDateAndTimeFormatted = getEventStartDateAndTime(event);
    const eventSportName = propz.get(event, ['sport', 'name'], '');
    const eventGender = SPORT_GENDER_SERVER_TO_CLIENT_MAPPING[event.gender] || '';
    const eventAgesCompact = formatAgesCompact(event.ages, ageGroupsNaming) || 'All ages';
    const eventSummaryTitle = [eventSportName, eventGender, eventAgesCompact].filter(Boolean).join(' · ');

    const classes = isStudentEventsModalOpen ? 'bSchoolTeamManager modal-open' : 'bSchoolTeamManager';
    const hardClashCount = itemsAccumulator.filter(
      participant =>
        (propz.get<any[]>(participant, ['clashes', 'fullClashEvents'], []) || []).length > 0 ||
        propz.get<string>(participant, ['clashes', 'status'], '') === 'FULL_CLASH'
    ).length;

    return (
      <div className={classes}>
        {this.state.selectionError && (
          <div className="alert alert-danger" role="alert">
            {this.state.selectionError}
          </div>
        )}
        {this.renderStudentEventsModal()}
        {this.renderExitConfirmationModal()}
        {this.renderHelpModal()}
        {this.renderMaxPlayersModal()}
        {this.renderSaveErrorModal()}
        <div className="bSchoolTeamManager__header">
          <div className="bSchoolTeamManager__summaryCard">
            <div className="bSchoolTeamManager__summaryMain">
              <div className="bSchoolTeamManager__summaryHeading">
                <div>
                  <div className="bSchoolTeamManager__summaryTitle">{eventSummaryTitle}</div>
                  <div className="bSchoolTeamManager__summaryDate">{eventStartDateAndTimeFormatted}</div>
                  {isShowTeamName && (
                    <label className={`bSchoolTeamManager__summaryTeamName${isError ? ' is-invalid' : ''}`}>
                      <span>
                        Team name <i aria-hidden="true">*</i>
                      </span>
                      <input
                        className="bSchoolTeamManager__input bSchoolTeamManager__input--compact"
                        type="text"
                        placeholder="e.g. U13 Basketball A"
                        onChange={this.onChangeTeamName}
                        value={teamName}
                        required
                        aria-required="true"
                        aria-invalid={isError}
                      />
                      {isError && <small>Enter team name</small>}
                    </label>
                  )}
                </div>

                {isHousesEvent(event) && (
                  <div className="bSchoolTeamManager__summarySetup">
                    <div className="bSchoolTeamManager__summaryHouse">
                      <span>House</span>
                      <strong>{house && house.name}</strong>
                    </div>
                  </div>
                )}
                {(!isClubEvent(event) || isTeamSportEvent(event)) && (
                  <div
                    className="bEventParticipantsMode"
                    role="tablist"
                    aria-label={isClubEvent(event) ? 'Participant editing mode' : 'Add team mode'}
                  >
                    <button
                      type="button"
                      role="tab"
                      aria-selected="true"
                      className="bEventParticipantsMode__btn bEventParticipantsMode__btn--active"
                    >
                      {isClubEvent(event) ? 'Edit participants' : 'Add new team'}
                    </button>
                    <button
                      type="button"
                      role="tab"
                      aria-selected="false"
                      className="bEventParticipantsMode__btn"
                      onClick={this.openExistingTeamMode}
                    >
                      {isClubEvent(event) ? 'Choose existing team' : 'Add existing team'}
                    </button>
                  </div>
                )}
              </div>
              {event &&
                isTournamentEvent(event) &&
                (() => {
                  const maxPlayers = propz.get(event, ['sport', 'defaultLimits', 'maxPlayers']);
                  const hasLimit = typeof maxPlayers === 'number' && maxPlayers > 0;
                  return hasLimit ? (
                    <div className="bSchoolTeamManager__summaryText mt-1" style={{ color: '#f0ad4e', fontWeight: 600 }}>
                      Max {maxPlayers} participants per school
                    </div>
                  ) : null;
                })()}
            </div>

            <HelpIconButton
              onClick={() => this.setState({ isHelpModalOpen: true })}
              label="How to manage participants on this page"
              title="How this step works"
            />
          </div>
        </div>

        <section className="bSchoolTeamManager__participantsCard">
          <div className="bSchoolTeamManager__participantsHead">
            <div>
              <h2 className="bSchoolTeamManager__participantsTitle">Select participants</h2>
              <div className="bSchoolTeamManager__participantsSubtitle">
                Double-click a row to move it instantly, or tick several and use the centre buttons. Changes apply when
                you save.
              </div>
            </div>
          </div>
          {itemsAccumulator.some(item => participantEligibilityWarning(item, event)) && (
            <div className="alert alert-warning" role="alert">
              Some participants do not match the event year groups or gender.
            </div>
          )}
          <div className="bSchoolTeamManager__participantsDivider" />
          <div className="bSchoolTeamManager__editorWrap">
            <TwoPanelEditor
              isSourceFirst
              itemsPresetFiltersLocked={false}
              itemsHeaderExtra={
                <label className="m-2">
                  <input
                    type="checkbox"
                    checked={!(itemsFilters.ages || []).length}
                    onChange={e =>
                      this.onReplaceItemsFilters({
                        ...itemsFilters,
                        ages: e.target.checked ? [] : (event.ages || []).map(String),
                        forms: []
                      })
                    }
                  />{' '}
                  Include students outside event year groups
                </label>
              }
              itemsPresetFilters={itemsPresetFilters}
              onReplaceItemsFilters={this.onReplaceItemsFilters}
              onItemsSearchChange={this.onItemsSearchChange}
              itemsSearchValue={this.state.itemsSearch}
              isItemsLoading={isItemsLoading}
              onSelectAllFilteredItemsClick={this.onSelectAllFilteredItemsClick}
              //items
              items={items.map(item => ({ ...item, eligibilityWarning: participantEligibilityWarning(item, event) }))}
              itemsTitle={'Eligible students'}
              itemsColumns={visibleItemsColumns}
              itemsSelected={itemsSelected}
              onItemClick={this.onItemClick}
              //items filters
              onItemsFilterChange={this.onItemsFilterChange}
              itemsFilters={itemsFilters}
              itemsFiltersOptions={itemsFiltersOptions}
              isShowItemsFilter={isShowItemsFilter}
              isItemsFiltered={isItemsFiltered}
              onItemsFilterClick={this.onItemsFilterClick}
              //accumulator
              itemsAccumulator={itemsAccumulator.map(item => ({
                ...item,
                eligibilityWarning: participantEligibilityWarning(item, event)
              }))}
              itemsAccumulatorTitle={'Participants'}
              itemsAccumulatorColumns={visibleAccumulatorColumns}
              onItemAccumulatorClick={this.onItemAccumulatorClick}
              itemsAccumulatorSelected={itemsAccumulatorSelected}
              onSelectVisibleAccumulatorItems={rows =>
                this.setState({
                  itemsAccumulatorSelected: [
                    ...itemsAccumulatorSelected,
                    ...rows.filter(
                      row =>
                        !itemsAccumulatorSelected.some(
                          selected => selected.id === row.id && selected.permissionId === row.permissionId
                        )
                    )
                  ],
                  itemsSelected: []
                })
              }
              //accumulator filters
              onItemsAccumulatorFilterChange={this.onItemsAccumulatorFilterChange}
              itemsAccumulatorFilters={itemsAccumulatorFilters}
              itemsAccumulatorFiltersOptions={itemsAccumulatorFiltersOptions}
              isShowItemsAccumulatorFilter={isShowItemsAccumulatorFilter}
              isItemsAccumulatorFiltered={isItemsAccumulatorFiltered}
              onItemsAccumulatorFilterClick={this.onItemsAccumulatorFilterClick}
              //buttons
              onAddClick={this.onAddClick}
              onRemoveClick={this.onRemoveClick}
              //counts
              itemsCount={itemsCount}
              itemsAccumulatorCount={itemsAccumulatorCount}
              //current pages
              itemAccumulatorCurrentPage={1}
              itemCurrentPage={itemCurrentPage}
              itemsSetCurrentPageParams={this.itemsSetCurrentPageParams}
              //items filter buttons
              itemsOnApplyFilterClick={this.itemsOnApplyFilterClick}
              itemsOnClearFilterClick={this.itemsOnClearFilterClick}
              //items accumulator filter buttons
              itemsAccumulatorOnApplyFilterClick={this.itemsAccumulatorOnApplyFilterClick}
              itemsAccumulatorOnClearFilterClick={this.itemsAccumulatorOnClearFilterClick}
              //items select checkbox
              onSelectAllItemsClick={this.onSelectAllItemsClick}
              onSelectAllItemsOnPageClick={this.onSelectAllItemsOnPageClick}
              onUnselectAllItemsClick={this.onUnselectAllItemsClick}
              isSelectAllItemsChecked={isSelectAllItemsChecked}
              //items accumulator select checkbox
              onSelectAllItemsAccumulatorClick={this.onSelectAllItemsAccumulatorClick}
              onSelectAllItemsAccumulatorOnPageClick={this.onSelectAllItemsAccumulatorOnPageClick}
              onUnselectAllItemsAccumulatorClick={this.onUnselectAllItemsAccumulatorClick}
              isSelectAllItemsAccumulatorChecked={isSelectAllItemsAccumulatorChecked}
              //items sort
              sortItemsDirection={sortItemsDirection}
              sortItemsColumnsName={sortItemsColumnsName}
              onSortItemsClick={this.onSortItemsClick}
              //items accumulator sort
              sortItemsAccumulatorDirection={sortItemsAccumulatorDirection}
              sortItemsAccumulatorColumnsName={sortItemsAccumulatorColumnsName}
              onSortItemsAccumulatorClick={this.onSortItemsAccumulatorClick}
              itemsAddBuffer={itemsAddBuffer}
              itemsRemoveBuffer={itemsRemoveBuffer}
              onCellItemsClick={this.onClashClick}
              onCellItemsAccumulatorClick={this.onClashClick}
              //column visibility – items panel
              itemsAllColumns={allItemsColumns}
              itemsHiddenFields={itemsHiddenFields}
              onToggleItemsColumn={this.onToggleItemsColumn}
              isItemsColumnToggleable={this.isColumnToggleable}
              //column visibility – accumulator panel
              itemsAccumulatorAllColumns={allAccumulatorColumns}
              itemsAccumulatorHiddenFields={itemsAccumulatorHiddenFields}
              onToggleItemsAccumulatorColumn={this.onToggleItemsAccumulatorColumn}
              isItemsAccumulatorColumnToggleable={this.isColumnToggleable}
            />
          </div>
        </section>
        <div className="bSchoolTeamManager__footer">
          <div className="bSchoolTeamManager__footerLeft">
            <div className="bSchoolTeamManager__selectionSummary">
              <strong>{itemsAccumulatorCount} selected</strong>
              {isShowStudentEventClashes && hardClashCount > 0 && (
                <span>
                  ⚠ {hardClashCount} selected {hardClashCount === 1 ? 'student has' : 'students have'} a clash
                </span>
              )}
            </div>
            {isShowFollowingEventsSection && (
              <SchoolEventClubEventRadioButtons onEditModeClick={this.onEditModeClick} editMode={editMode} />
            )}
          </div>

          <div className="bSchoolTeamManager__footerRight">
            <button
              type="button"
              className="bSchoolTeamManager__btnSecondary"
              onClick={this.goBackWithOrWithoutConfirmation}
            >
              Cancel
            </button>
            <button type="button" className="bSchoolTeamManager__btnPrimary" onClick={this.onClickSave}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20 6 9 17l-5-5" />
              </svg>
              {isClubEvent(event) ? 'Save participants' : 'Save squad'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
